import React from 'react';
import { Modal } from 'antd';

import styles from './styles.module.less';

const YoutubeModal: React.FC<{
  open: boolean;
  onClose: () => void;
  videoWidth: number;
  videoHeight: number;
  videoLink: string;
}> = ({ open, onClose, videoWidth, videoHeight, videoLink }) => (
  <Modal
    className={styles.youtubeModal}
    width={825}
    title={null}
    closeIcon={null}
    open={open}
    footer={null}
    onOk={onClose}
    onCancel={onClose}
    destroyOnClose
  >
    <div className={styles.videoContent} style={{ height: videoHeight, width: videoWidth }}>
      <iframe
        width={videoWidth}
        height={videoHeight}
        src={videoLink}
        title='YouTube video player'
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        allowfullscreen
      />
    </div>
  </Modal>
);

export default YoutubeModal;
